module.exports = __webpack_public_path__ + "static/media/srm.c4b6ed6e.png";